// extracted by mini-css-extract-plugin
module.exports = {"item":"_80ad21f8ef--item--VLOhC","item-title":"_80ad21f8ef--item-title--3ZzM_","item-subtitle":"_80ad21f8ef--item-subtitle--3j7XN","custom-list":"_80ad21f8ef--custom-list--3gKJ4"};